module.exports = __webpack_public_path__ + "img/2174.2d829652.gif";